export const strMatcher =
  <T extends string, R>(adts: Record<T, () => R>) =>
  (v: T) =>
    adts[v]();
